function customerAccident() {
  // promenne
  var $existingCollectionHolder = $('.form-items');
  var $addItemButton = $('.add-item-button');

  // smaze dany radek
  $('.remove-item-link').on('click', function () {
    $(this).closest('.form-item').remove();
  });

  // po kliknuti na "Pridat dalsi polozku"
  $addItemButton.on('click', function (e) {
    // se zavola funkce, ktera prida novy radek
    addItemForm($existingCollectionHolder, $addItemButton);

    // smaze dany radek (duplicitni s radky 8-10 protoze zde jsou dynamicky vytvorene html elementy, na ktere ten on click event vyse jiz neplati)
    $('.remove-item-link').on('click', function () {
      $(this).closest('.form-item').remove();
    });
  });

  // prida novy radek
  function addItemForm($existingCollectionHolder, $newButton) {
    var newForm = $existingCollectionHolder.data('prototype');
    var index = $existingCollectionHolder.data('index');

    // nahradi vsechny vyskyty spravnym cislem
    newForm = newForm.replace(/__name__label__/g, index);
    newForm = newForm.replace(/__name__/g, index);

    // navysi index o 1
    $existingCollectionHolder.data('index', index + 1);

    // vlozi novou polozku pred tlacitko
    $newButton.before(newForm);
    $('.select-selected').remove();
    $('.select-items .select-hide').remove();

    const customSelects = document.getElementsByClassName('custom-select');
    for (let i = 0; i < customSelects.length; i++) {
      initializeCustomSelect(customSelects[i]);
      new SimpleBar(document.querySelectorAll('.select-items')[i], {
        autoHide: false,
      });
    }
  }

  $(document).ready(function () {
    addItemForm($existingCollectionHolder, $addItemButton);
    $('.remove-item-link').on('click', function () {
      $(this).closest('.form-item').remove();
    });

    Dropzone.autoDiscover = false;
    $('#claimFiles').dropzone({
      url: $('#dropZonePath').data('path'),
      addRemoveLinks: true,
      success: function (file, response) {
        var imgName = response;
        file.previewElement.classList.add('dz-success');
        console.log('Successfully uploaded :' + imgName);
      },
      error: function (file, response) {
        file.previewElement.classList.add('dz-error');
      },
    });
  });
}
